import { useQuery } from '@tanstack/react-query';
import QueryKeys from '../utils/QueryKeys';
import { Student } from '../models';

export default function useStudent(studentParams) {
  const isEnabled = Object.keys(studentParams).length > 0
                    && Object.values(studentParams).filter((val) => !!val).some((val) => val);

  return useQuery([QueryKeys.STUDENT, studentParams], () => (
    Student
      .includes('school')
      .where(studentParams)
      .first()
      .then((res) => res.data)
  ), { enabled: isEnabled });
}
